import { motion } from "framer-motion";
import { useEffect } from "react";

export const EASE = [0.22, 1, 0.36, 1];

export function Reveal({ children, delay = 0, y = 28, className = "", once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-60px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLines({ lines, className = "", lineClassName = "", delay = 0, as = "span" }) {
  const Tag = as;
  return (
    <Tag className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block ${lineClassName}`}
            initial={{ y: "112%" }}
            animate={{ y: 0 }}
            transition={{ duration: 1.05, delay: delay + i * 0.14, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </Tag>
  );
}

export function Marquee({ items, className = "" }) {
  const strip = [...items, ...items];
  return (
    <div className={`overflow-hidden bg-sage-light py-5 border-y border-subtle ${className}`} aria-hidden="true">
      <div className="animate-marquee flex w-max items-center whitespace-nowrap">
        {strip.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif-d text-xl sm:text-2xl text-blue italic px-8">{item}</span>
            <span className="h-1.5 w-1.5 rotate-45 bg-sage" />
          </span>
        ))}
      </div>
    </div>
  );
}

export function SEO({ title, description }) {
  useEffect(() => {
    document.title = title;
    let meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", description);
  }, [title, description]);
  return null;
}

export function Eyebrow({ children, className = "" }) {
  return (
    <p className={`font-mono text-xs uppercase tracking-[0.25em] text-sage-dark ${className}`}>
      {children}
    </p>
  );
}
